/**
 * @desc 扫描BOX获取BOX信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inPlateMaster.scanBox.Params, options?: any) {
  return updateResponse(
    http(URL + `/inPlate/scanBox`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
